module.exports = __webpack_public_path__ + "media/npc_dota_hero_life_stealer.1065fb48.webm";